<template>
  <div class="card card-article has-background-table-second-color mgb-10px">
    <div class="columns is-marginless is-paddingless">
      <div class="column is-4">
        <b-input disabled :value="ligne.tiers.nomCommercial">
        </b-input>
      </div>
      <div class="column is-4">
        <input-currency v-model="ligne.pourcentage" disabled>
        </input-currency>
      </div>
    </div>
  </div>
</template>

<script>

import inputCurrency from '@/components/general/inputCurrency';

export default {
  props: {
    ligne: {
      type: Object,
      required: true,
    },
  },
  components: {
    inputCurrency,
  },
};
</script>
